import React, { memo } from 'react';
import { array } from 'prop-types';
import OrderLineItem from '../OrderLineItem';

const OrderLines = ({
  orderLines, ...rest
}) => {
  if (orderLines.length === 0) {
    return null;
  }

  return (
    <div className="order-detail__content-orderLine cui-mg-t-20">
      {
        orderLines.map((orderLine, idx) => {
          return (
            <React.Fragment key={idx}>
              <OrderLineItem key={idx} {...orderLine} {...rest} className="orderline-item"/>
              {idx < orderLines.length - 1 && <div className="hr-line"></div>}
            </React.Fragment>
          );
        })
      }
    </div>
  );
};

OrderLines.propTypes = {
  orderLines: array,
};

OrderLines.defaultProps = {
  orderLines: [],
};

export default memo(OrderLines);
